import React, { useRef } from 'react';
import classnames from 'classnames';
import PopoverArrow from '../PopoverArrow';
import PopoverContainer from '../PopoverContainer';
import s from './DefaultPopoverContent.scss';
/** This is our basic popover with the default styles applied */ const DefaultPopoverContent = ({ effectivePlacement , arrowClassName , wrapperClassName , contentClassName , oneLine , noPadding , noMinWidth , noMaxWidth , width , height , showArrow , arrowRef , arrowStyle , arrowAttributes , children , rootRef , contentStyle , contentAttributes , onClickOutside , directionalClassNames , role , 'aria-label': ariaLabel , onMouseEnter , onMouseLeave , onKeyDown , updatePositioning ,  })=>{
    var ref, ref1;
    const contentRef = useRef(null);
    return /*#__PURE__*/ React.createElement(PopoverContainer, {
        ref: rootRef,
        placement: effectivePlacement,
        style: contentStyle,
        attributes: contentAttributes,
        directionalClassNames: directionalClassNames,
        role: role,
        "aria-label": ariaLabel,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: onKeyDown,
        innerRef: contentRef,
        wrapperClassName: classnames(s['popper-wrapper'], showArrow && s[`arrow-${effectivePlacement}`], wrapperClassName),
        contentClassName: classnames(s['popper-content'], oneLine && s['one-line'], !noPadding && s['with-padding'], !noMinWidth && s['with-min-width'], !noMaxWidth && s['with-max-width'], contentClassName),
        width: width,
        height: height,
        arrow: showArrow && /*#__PURE__*/ React.createElement(PopoverArrow, {
            ref: arrowRef,
            placement: effectivePlacement,
            contentWidth: contentRef === null || contentRef === void 0 ? void 0 : (ref = contentRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth,
            contentHeight: contentRef === null || contentRef === void 0 ? void 0 : (ref1 = contentRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight,
            className: classnames(s['arrow'], arrowClassName),
            style: arrowStyle,
            attributes: arrowAttributes
        }),
        onClickOutside: onClickOutside,
        updatePositioning: updatePositioning
    }, children);
};
DefaultPopoverContent.displayName = 'DefaultPopoverContent';
export default DefaultPopoverContent;
